import { Component, OnInit } from '@angular/core';
import { SignupWizardService } from '../signup-wizard.service';

@Component({
  standalone: false,
  selector: 'sbnb-signup-start',
  templateUrl: './signup-start.component.html',
  styleUrls: ['./signup-start.component.scss'],
})
export class SignupStartComponent implements OnInit {
  saving: boolean;

  constructor(public wizard: SignupWizardService) { }

  ngOnInit() {
    if (!this.wizard.signupUser.token) {
      this.wizard.cancel();
    }

    if (this.wizard.signupUser.current_step < 3) {
      this.wizard.cancel();
    }
  }

  next() {
    this.saving = true;

    this.wizard.goToStep(4).subscribe(
      (res) => {
        this.wizard.next();
        this.saving = false;
      },
      () => {
        this.saving = false;
      }
    );
  }
}
